import React, { useState, useMemo } from 'react';
import { VStack, StackDivider, Text } from '@chakra-ui/react';
import { EmailForm, ThemeUser } from '../common';
import { useCustomThemeDraftState } from '@olo-web/client-state';
import { ECustomThemeViews } from '@olo-web/types/enums';
import { useMerchantTheme } from '@domain/merchants/queries/useMerchantTheme';

const CurrentUserAccess = () => {
  const { data: theme } = useMerchantTheme();

  const [owners, editors]: [string[], string[]] = useMemo(() => {
    return [theme?.owners || [], theme?.editors || []];
  }, [theme?.editors, theme?.owners]);

  return (
    <VStack w="100%" align="flex-start" spacing={6} divider={<StackDivider />}>
      <VStack w="100%" align="flex-start" spacing={4}>
        <Text textStyle="subtitle1">Owners</Text>
        {!owners?.length ? (
          <Text textStyle="p">No theme owners</Text>
        ) : (
          owners.map((uid) => <ThemeUser key={`owner-${uid}`} uid={uid} />)
        )}
      </VStack>
      <VStack w="100%" align="flex-start" spacing={4}>
        <Text textStyle="subtitle1">Editors</Text>
        {!editors?.length ? (
          <Text textStyle="p">No theme editors</Text>
        ) : (
          editors.map((uid) => <ThemeUser key={`editor=${uid}`} uid={uid} />)
        )}
      </VStack>
    </VStack>
  );
};

export const ThemeUsers = () => {
  const [emails, setEmails] = useState<string[]>([]);
  const { view } = useCustomThemeDraftState();

  const handleSubmit = (email: string) => {
    setEmails((prev) => [...prev, email]);
  };

  return (
    <VStack spacing={6} w="100%" divider={<StackDivider />}>
      <VStack spacing={6} w="100%">
        <EmailForm emails={emails} onSubmit={handleSubmit} />
        {emails.map((email) => (
          <ThemeUser email={email} key={email} />
        ))}
      </VStack>
      {view === ECustomThemeViews.MANAGE_ACCESS && <CurrentUserAccess />}
    </VStack>
  );
};
